import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b82a324e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark background" }
const _hoisted_2 = { class: "navbar-container" }
const _hoisted_3 = { class: "container-fluid d-flex justify-content-between" }
const _hoisted_4 = {
  class: "d-flex",
  style: {"align-items":"center"}
}
const _hoisted_5 = { class: "bottom-container" }
const _hoisted_6 = {
  class: "navbar-nav menu",
  style: {"align-items":"center"}
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "profileMenu-icon" }
const _hoisted_9 = {
  key: 0,
  class: "profileMenu__dropdown"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "profileMenu__dropdown-info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "My profile", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Logout ", -1 /* HOISTED */))
const _hoisted_15 = { class: "header" }
const _hoisted_16 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"space-around","margin":"10px 0"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Connected to:", -1 /* HOISTED */))
const _hoisted_20 = { class: "net-changer" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-b82a324e><circle opacity=\"0.2\" cx=\"13\" cy=\"13\" r=\"6\" fill=\"#088201\" data-v-b82a324e><animate attributeName=\"r\" values=\"6;9;6\" dur=\"2s\" repeatCount=\"indefinite\" data-v-b82a324e></animate></circle><circle cx=\"13\" cy=\"13\" r=\"3\" fill=\"#088201\" data-v-b82a324e><animate attributeName=\"r\" values=\"1;4;1\" dur=\"2s\" repeatCount=\"indefinite\" data-v-b82a324e></animate></circle></svg>", 1)
const _hoisted_22 = ["value", "selected"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "Navigation", -1 /* HOISTED */))
const _hoisted_24 = { class: "sidebar-element" }
const _hoisted_25 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" <nav class=\"navbar navbar-expand-lg navbar-dark background\">\n    <LoginPopUp v-if=\"loginPopupStatus\" @close=\"loginPopupStatus =! loginPopupStatus\"/>\n    <LogoutKeplr v-if=\"logoutPopupStatus === true\" :logout-type=\"useUserStore().getConnectionType\" @close=\"logoutPopupStatus = false\"></LogoutKeplr>\n  <div class=\"navbar-container\">\n\n    <div class=\"container-fluid d-flex justify-content-between\">\n      <span class=\"d-flex\" style=\"align-items: center\">\n      <Image class=\"navbar-brand\" :src=\"require('../../assets/c4elogo-new.svg')\" alt=\"Image\" height=\"36\" />\n      </span>\n\n        <div class=\"navbar-nav\" style=\"align-items: center\">\n\n          <div @click=\"openAccInfo\"  class=\"acc-address\" v-if=\"useUserStore().isLoggedIn\">\n            <KeplrLogo v-if=\"useUserStore().connectionInfo.isKeplr()\"/>\n            <Icon v-if=\"useUserStore().connectionInfo.isAddress()\" style=\"margin-right: 10px;\" name=\"Globe\"></Icon>\n            <span v-if=\"useUserStore().connectionInfo.accountName\">{{ useUserStore().connectionInfo.accountName}}: </span>\n            {{ useUserStore().getAccount.address.slice(0, 8)}}...{{useUserStore().getAccount.address.slice(-6) }}\n          </div>\n\n          <LangSwitch class=\"nav-link mx-1\"/>\n\n          <Button v-if=\"!useUserStore().isLoggedIn\" class=\"secondary\" @click=\"loginPopupStatus =! loginPopupStatus\">{{ $t('COMMON.CONNECT') }}</Button>\n\n          <Button v-if=\"useUserStore().isLoggedIn\" class=\"secondary\" @click=\"logout\">{{ $t('COMMON.DISCONNECT') }}</Button>\n\n\n        </div>\n      </div>\n\n    <div class=\"bottom-container\">\n      <h2>{{$t(\"SECTION_TITLES.\" + currentRouteName?.toUpperCase())}}</h2>\n        <breadcrumbs-component />\n    </div>\n    <UserData v-if=\"useUserStore().isLoggedIn\"/>\n    </div>\n  </nav> "),
    _createElementVNode("nav", _hoisted_1, [
      ($setup.loginPopupStatus)
        ? (_openBlock(), _createBlock($setup["LoginPopUp"], {
            key: 0,
            onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
          }))
        : _createCommentVNode("v-if", true),
      ($setup.logoutPopupStatus === true)
        ? (_openBlock(), _createBlock($setup["LogoutKeplr"], {
            key: 1,
            "logout-type": $setup.useUserStore().getConnectionType,
            onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.logoutPopupStatus = false))
          }, null, 8 /* PROPS */, ["logout-type"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("div", {
              class: "navbar-brand",
              style: {"display":"flex","flex-direction":"column","text-align":"center"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onLogoClick()))
            }, [
              _createCommentVNode("            <div style=\"text-align:center\">"),
              _createVNode(_component_Image, {
                src: require('../../assets/c4elogo-new.svg'),
                alt: "Image",
                height: "36"
              }, null, 8 /* PROPS */, ["src"]),
              _createCommentVNode("            </div>"),
              _createCommentVNode("            <div>"),
              _createCommentVNode("            <TokenPriceComponent style=\"font-size: 0.8rem; margin-top: 4px\"></TokenPriceComponent>"),
              _createCommentVNode("              <span style=\"font-size: 0.8rem; margin-top: 4px\" >{{useTokensStore().getTokenPrice.price}} USD</span>"),
              _createCommentVNode("            </div>")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("SECTION_TITLES." + $setup.currentRouteName?.toUpperCase())), 1 /* TEXT */),
              _createVNode($setup["BreadcrumbsComponent"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            ($setup.useUserStore().isLoggedIn)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: $setup.openAccInfo,
                  class: "acc-address"
                }, [
                  ($setup.displayLogo)
                    ? (_openBlock(), _createBlock($setup["KeplrLogo"], {
                        key: 0,
                        letter: $setup.getLetter()
                      }, null, 8 /* PROPS */, ["letter"]))
                    : _createCommentVNode("v-if", true),
                  ($setup.useUserStore().connectionInfo.isAddress())
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 1,
                        style: {"margin-right":"10px"},
                        name: "Globe"
                      }))
                    : _createCommentVNode("v-if", true),
                  ($setup.useUserStore().connectionInfo.accountName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.useUserStore().connectionInfo.accountName) + ": ", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(" " + _toDisplayString($setup.useUserStore().getAccount.address.slice(0, 8)) + "..." + _toDisplayString($setup.useUserStore().getAccount.address.slice(-6)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["LangSwitch"], { class: "nav-link mx-1" }),
            (!$setup.useUserStore().isLoggedIn)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "secondary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('COMMON.CONNECT')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.useUserStore().isLoggedIn)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  class: "secondary",
                  onClick: $setup.logoutWallet
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('COMMON.DISCONNECT')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.useConfigurationStore().config.publicSaleVisible === true)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "profileMenu",
                  onFocusout: $setup.closeProfileDropdown,
                  tabindex: "0",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggleProfileDropdown()))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode($setup["UserIcon"], {
                      style: _normalizeStyle($setup.useUserServiceStore().isLoggedIn ? 'color: #81CF1F' : '')
                    }, null, 8 /* PROPS */, ["style"])
                  ]),
                  ($setup.profileDropdown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (!$setup.useUserServiceStore().isLoggedIn)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", {
                                class: "option grid_container",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => {$setup.router.push({name: 'signIn-profile'});})
                              }, [
                                _createVNode(_component_Icon, { name: "LogIn" }),
                                _createTextVNode(" Login to profile ")
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.useUserServiceStore().userEmail), 1 /* TEXT */),
                              _createElementVNode("div", {
                                class: "option grid_container",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => {$setup.router.push({name: 'userProfileTabs'});})
                              }, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_Icon, { name: "User" })
                                ]),
                                _hoisted_13
                              ]),
                              _createElementVNode("div", {
                                class: "option grid_container",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => {$setup.logoutAccount();})
                              }, [
                                _createVNode(_component_Icon, { name: "LogOut" }),
                                _hoisted_14
                              ])
                            ]))
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 32 /* NEED_HYDRATION */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", {
            class: "navbar-nav mobile",
            onClick: $setup.toggleDropdown,
            style: {"align-items":"center"}
          }, [
            _createVNode(_component_Icon, { name: "Menu" })
          ])
        ]),
        ($setup.useUserStore().isLoggedIn)
          ? (_openBlock(), _createBlock($setup["UserData"], { key: 0 }))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mobile-menu", $setup.dropdown ? 'mobile-menu-open' : ''])
      }, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Image, {
            class: "navbar-brand",
            src: require('../../assets/c4elogo-new.svg'),
            alt: "Image",
            height: "36"
          }, null, 8 /* PROPS */, ["src"]),
          _createElementVNode("div", { onClick: $setup.toggleDropdown }, [
            _createVNode(_component_Icon, { name: "X" })
          ])
        ]),
        _createCommentVNode(" <div class=\"divider\"></div> "),
        ($setup.useUserStore().isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: $setup.openAccInfo,
              class: "acc-address"
            }, [
              ($setup.useUserStore().connectionInfo.isKeplr())
                ? (_openBlock(), _createBlock($setup["KeplrLogo"], { key: 0 }))
                : _createCommentVNode("v-if", true),
              ($setup.useUserStore().connectionInfo.isAddress())
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    style: {"margin-right":"10px"},
                    name: "Globe"
                  }))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_16, [
                ($setup.useUserStore().connectionInfo.accountName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($setup.useUserStore().connectionInfo.accountName) + ": ", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString($setup.useUserStore().getAccount.address.slice(0, 8)) + "..." + _toDisplayString($setup.useUserStore().getAccount.address.slice(-6)) + " ", 1 /* TEXT */),
                ($setup.useUserStore().isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "secondary",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => {$setup.logoutWallet(); $setup.toggleDropdown()})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('COMMON.DISCONNECT')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (!$setup.useUserStore().isLoggedIn)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              style: {"width":"90%"},
              class: "secondary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => {$setup.toggleDropdown(); $setup.loginPopupStatus =! $setup.loginPopupStatus})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('COMMON.CONNECT')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", null, [
            _createElementVNode("span", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("select", {
                class: "currentBlockchain__selector",
                onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.onChange($event)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.configMap, ([key, item]) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: key,
                    selected: $setup.curentNetwork === item.networkName
                  }, _toDisplayString(item.networkName), 9 /* TEXT, PROPS */, _hoisted_22))
                }), 128 /* KEYED_FRAGMENT */))
              ], 32 /* NEED_HYDRATION */)
            ])
          ])
        ]),
        _hoisted_23,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menu, (menuItem, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: menuItem.href,
            key: index,
            onClick: $setup.toggleDropdown
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_24, [
                _createElementVNode("span", {
                  class: _normalizeClass(["icon", { 'active': index === $setup.selected }])
                }, [
                  (menuItem.icon.type === $setup.SideBarIconType.LUCIDE)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 0,
                        name: menuItem.icon.element
                      }, null, 8 /* PROPS */, ["name"]))
                    : (menuItem.icon.type === $setup.SideBarIconType.GOV)
                      ? (_openBlock(), _createBlock($setup["GovernanceIcon"], {
                          key: 1,
                          icon: menuItem.icon.element
                        }, null, 8 /* PROPS */, ["icon"]))
                      : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */),
                _createElementVNode("span", _hoisted_25, _toDisplayString(menuItem.title), 1 /* TEXT */)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}